import { useState } from 'react';

export const CLIENT_PORTAL_SIDEBAR_COLLAPSE_STORAGE_KEY = 'client-portal-sidebar-open';

function readStoredOpen(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  try {
    return window.localStorage.getItem(CLIENT_PORTAL_SIDEBAR_COLLAPSE_STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
}

function persistOpen(next: boolean): void {
  try {
    window.localStorage.setItem(CLIENT_PORTAL_SIDEBAR_COLLAPSE_STORAGE_KEY, String(next));
  } catch {
    return;
  }
}

export function useClientPortalSidebarCollapse() {
  const [open, setOpen] = useState(readStoredOpen);

  function setOpenAndPersist(next: boolean) {
    setOpen(next);
    persistOpen(next);
  }

  return { open, setOpen: setOpenAndPersist };
}
